export default __webpack_public_path__ + "static/media/main-background.5db02a86.jpg";